import { Navigate, useParams } from "react-router-dom";
import InvestorPageShell from "../../../components/Investor/InvestorPageShell";
import InvestorRequestsNav from "../../../components/Investor/InvestorRequestsNav";
import InvestorRequestDetailContent from "../../../components/Investor/InvestorRequestDetailContent";
import RealEstateRequestDetailContent from "../../../components/Investor/RealEstateRequestDetailContent";
import { useGetInvestorInvestmentRequestQuery } from "../../../store/investor/investorInvestmentsApi";
import { useGetRealEstateRequestQuery } from "../../../store/investor/investorRealEstateApi";
import { mapInvestorRequestToDetailShape } from "../../../utils/investorInvestmentsAdapter";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";

function looksLikeRealEstateReference(id) {
  return String(id || "").toUpperCase().startsWith("REA-");
}

export default function InvestorRequestDetailPage() {
  const { requestId } = useParams();
  const preferRealEstate = looksLikeRealEstateReference(requestId);

  const investmentQuery = useGetInvestorInvestmentRequestQuery(requestId, {
    skip: !requestId || preferRealEstate,
  });

  const shouldTryRealEstate =
    Boolean(requestId) && (preferRealEstate || investmentQuery.isError);

  const realEstateQuery = useGetRealEstateRequestQuery(requestId, {
    skip: !shouldTryRealEstate,
  });

  const isFetching =
    (!preferRealEstate && investmentQuery.isFetching) ||
    (shouldTryRealEstate && realEstateQuery.isFetching);

  if (isFetching) {
    return (
      <InvestorPageShell
        wide
        backTo="/invest/requests"
        backLabel="Back to my requests"
        title="Request details"
      >
        <TableSkeletonLoader rows={5} columns={2} />
      </InvestorPageShell>
    );
  }

  if (realEstateQuery.data) {
    return (
      <InvestorPageShell
        wide
        backTo="/invest/requests?filter=real_estate"
        backLabel="Back to my requests"
        title="Property request"
        subtitle="Review status, inspection details, and next steps."
      >
        <InvestorRequestsNav />
        <RealEstateRequestDetailContent request={realEstateQuery.data} />
      </InvestorPageShell>
    );
  }

  if (investmentQuery.data) {
    const request = mapInvestorRequestToDetailShape(investmentQuery.data);
    return (
      <InvestorPageShell
        wide
        backTo="/invest/requests"
        backLabel="Back to my requests"
        title="Request details"
        subtitle="Review submission status and contact information."
      >
        <InvestorRequestsNav />
        <InvestorRequestDetailContent request={request} />
      </InvestorPageShell>
    );
  }

  return <Navigate to="/invest/requests" replace />;
}
